<template>
    <div v-if="pindahGudang">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 v-if="isPenerimaan" class="modal-title">Penerimaan Pemindahan Gudang</h5>
                <h5 v-else-if="isPelunasan" class="modal-title">Pelunasan Pemindahan Gudang</h5>
                <h5 v-else class="modal-title">{{ pindahGudang.id ? 'Informasi' : 'Konfirmasi' }} Pemindahan Gudang</h5>
            </b-card-header>
            <b-card-body>
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Gudang Asal</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pindahGudang.gudang_asal.name }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Gudang Tujuan</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pindahGudang.gudang_tujuan.name }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal Berangkat</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(pindahGudang.tanggal_berangkat) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Pengirim</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pindahGudang.pengirim }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Biaya</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(pindahGudang.total_biaya) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Uang Muka</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(pindahGudang.dp) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Metode Uang Muka</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pindahGudang.metode_dp.value ? pindahGudang.metode_dp.value : pindahGudang.metode_dp }}</th>
                        </tr>
                        <tr v-if="!isKonfirmasi">
                            <th class="fit-column">Pelunasan</th>
                            <td class="fit-column">:</td>
                            <td v-if="isPelunasan" class="text-primary">
                                <input v-validate="'required|min_value:0'" min="0" v-model="form.pelunasan" type="number" name="pelunasan" class="form-control">
                                <span class="text-danger">{{ errors.first('pelunasan') }}</span>
                            </td>
                            <th v-else class="text-primary">{{ pindahGudang.pelunasan ? formatNumber(pindahGudang.pelunasan.pelunasan) : '-' }}</th>
                        </tr>
                        <tr v-if="!isKonfirmasi">
                            <th class="fit-column">Metode Pelunasan</th>
                            <td class="fit-column">:</td>
                            <td v-if="isPelunasan">
                                <div class="input-group single mb-0 d-flex">
                                    <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode_pelunasan" v-model="form.metode_pelunasan" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                        label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                </div>
                                <span class="text-danger">{{ errors.first('metode_pelunasan') }}</span>
                            </td>
                            <th v-else class="text-primary">{{ pindahGudang.pelunasan ? pindahGudang.pelunasan.metode_pelunasan : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Berat Berangkat (kg)</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(totalBobotBerangkat) }}</th>
                        </tr>
                        <tr v-if="!isKonfirmasi">
                            <th class="fit-column">Berat Tiba (kg)</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(pindahGudang.bobot_tiba) }}</th>
                        </tr>
                    </table>
                </div>

                <label class="form-control-label mt-3 pl-1">
                    Detail Barang
                </label>
                <div class="alert alert-primary mb-1" role="alert">
                    Total Inputan : <strong class="text-nowrap">{{ formatNumber(pindahGudang.kemasans.length) }}</strong>
                </div>
                <div class="row mb-2 pl-1">
                    <div class="col-12 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <label class="mr-2 mb-0">Pencarian</label>
                            <input type="text" style="min-width: 100px; max-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="searchBarang"
                                placeholder="kode...">
                            <button @click="scanBarang = true" type="button" class="btn btn-primary mr-1">Scan</button>
                            <button @click="searchBarang()" type="button" class="btn btn-primary">Cari</button>
                            <button @click="resetSearchBarang()" type="button" class="btn btn-light">Reset</button>
                        </div>
                        <button :disabled="isLoading" v-if="isPenerimaan" @click="loadPilihan()" type="button" class="btn btn-primary text-nowrap"><i class="fas fa-sync-alt"></i> Load Pilihan</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <tr>
                            <th>No.</th>
                            <th>Kode</th>
                            <template v-if="isKonfirmasi">
                                <th>Berat</th>
                                <th>Grade</th>
                            </template>
                            <template v-else>
                                <th>Berat Berangkat</th>
                                <th>Berat Tiba</th>
                                <th>Grade Berangkat</th>
                                <th>Grade Tiba</th>
                                <th></th>
                            </template>
                        </tr>
                        <tr v-for="(item, index) in pindahGudang.kemasans" v-show="!filterCode || parseInt(item.pembelian_tembakau.code) == parseInt(filterCode)">
                            <th class="text-primary pl-0">
                                {{ index+1 }}
                            </th>
                            <th class="text-primary pl-0">
                                {{ isKonfirmasi ? formatValue(item.code) : formatValue(item.pembelian_tembakau.code) }}
                            </th>
                            <template v-if="isKonfirmasi">
                                <th class="text-primary">
                                    {{ item.latest_bobot ? formatNumber(item.latest_bobot) + ' KG' : '-' }}
                                </th>
                                <th class="text-primary pr-0">
                                    {{ item.latest_grade ? item.latest_grade.name : '-' }}
                                </th>
                            </template>
                            <template v-else>
                                <th class="text-primary">
                                    {{ item.bobot_berangkat ? formatNumber(item.bobot_berangkat) + ' KG' : '-' }}
                                </th>
                                <td v-if="isPenerimaan" class="text-primary">
                                    <input style="width: 7rem;" min="0" v-model="form.kemasans[index].bobot_tiba" type="number" :name="'bobot_tiba'+index" class="form-control">
                                </td>
                                <th v-else class="text-primary">
                                    {{ item.bobot_tiba ? formatNumber(item.bobot_tiba) + ' KG' : '-' }}
                                </th>
                                <th class="text-primary">
                                    {{ item.grade_berangkat ? item.grade_berangkat.name : '-' }}
                                </th>
                                <td v-if="isPenerimaan" class="text-nowrap pl-0 fit-column">
                                    <div :class="(gradeLoaded ? '' : 'input-group ') + 'mb-0 d-flex'" style="width: 10rem;">
                                        <multiselect :style="gradeLoaded ? 'width:10rem; max-width: 10rem;' : 'width:5rem; max-width: 5rem;'" :class="'w-auto flex-grow-1'" v-model="form.kemasans[index].grade_tiba" @input="updateGrade" :options="gradeOptions" placeholder="" :searchable="true"
                                            label="name" track-by="id" :allowEmpty="false" :name="'grade_tiba'+index" :show-labels="false" openDirection="bottom"></multiselect>
                                        <div v-if="!gradeLoaded" class="input-group-append">
                                            <button class="btn btn-primary" type="button" @click="findGrade(index)"><i class="fas fa-search"></i> Pilih</button>
                                        </div>
                                    </div>
                                </td>
                                <th v-else class="text-primary pr-0">
                                    {{ item.grade_tiba ? item.grade_tiba.name : '-' }}
                                </th>
                                <th v-if="!isKonfirmasi" class="fit-column text-center">
                                    <button :disabled="isLoading" type="button" title="Print QrCode" @click="printQrCode(item.pembelian_tembakau)" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                                </th>
                            </template>
                        </tr>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('koreksi')" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('ok')" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi && !isPenerimaan && !isPelunasan" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                <button :disabled="isLoading" v-if="isPenerimaan || isPelunasan" @click="save" type="button" class="btn btn-primary mr-2">Simpan</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGrade" size="lg" :hide-header="true" :hide-footer="true">
            <grade-selector @selected="gradeSelected" @cancel="selectGrade = false"></grade-selector>
        </b-modal>

        <b-modal v-model="scanBarang" size="md" :hide-header="true" :hide-footer="true">
            <scan-qr-code @decoded="scanned"></scan-qr-code>
		</b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GradeSelector from '../grades/Selector';
import ScanQrCode from '../../components/ScanQrCode';

export default {
    name: "pindah-gudang-viewer",

    props: {
        isKonfirmasi: {
            type: Boolean,
            default: false,
        },

        isPenerimaan: {
            type: Boolean,
            default: false,
        },

        isPelunasan: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
        GradeSelector,
        ScanQrCode,
    },

    data() {
        return {
            pindahGudang: null,
            kemasanIndex: 0,
            selectGrade: false,
            gradeOptions: [],
            form: {
                kemasans: [],
            },
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
            searchText: '',
            filterCode: '',
            gradeLoaded: false,
            scanBarang: false,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initPindahGudang();
        }
    },

    computed: {
        totalBobotBerangkat() {
            let total = 0;
            this.pindahGudang.kemasans.forEach(kemasan => {
                total += this.isKonfirmasi ? kemasan.latest_bobot : kemasan.bobot_berangkat;
            });

            return total;
        },
    },

    watch: {
        value() {
            this.initPindahGudang();
        }
    },

    methods: {
        initPindahGudang() {
            let self = this;

            self.pindahGudang = Object.assign({}, self.value);

            if (self.isKonfirmasi) {
                self.pindahGudang.kemasans = self.value.barangs;
            }

            if (self.isPenerimaan) {
                self.pindahGudang.kemasans.forEach((kemasan, index) => {
                    self.form.kemasans[index] = Object.assign({}, {
                        id: kemasan.id,
                        bobot_tiba: kemasan.bobot_tiba || '',
                        grade_tiba: kemasan.grade_tiba ? Object.assign({}, kemasan.grade_tiba) : null,
                    });
                });
            }

            if (self.isPelunasan && self.pindahGudang.pelunasan) {
                let metodePelunasanIndex = self.metodeOptions.findIndex(option => option.name == self.pindahGudang.pelunasan.metode_pelunasan);
                self.form.pelunasan = self.pindahGudang.pelunasan.pelunasan;
                self.form.metode_pelunasan = Object.assign({}, self.metodeOptions[metodePelunasanIndex]);
            }
        },

        findGrade(index) {
            this.kemasanIndex = index;
            this.selectGrade = true;
        },

        gradeSelected(grade) {
            let self = this;

            let index = self.gradeOptions.findIndex(b => b.id == grade.id);
            if (index > -1) {
                self.form.kemasans[self.kemasanIndex].grade_tiba = Object.assign({}, self.gradeOptions[index]);
            } else {
                self.form.kemasans[self.kemasanIndex].grade_tiba = Object.assign({}, grade);
                self.gradeOptions.push(grade);
            }
            self.selectGrade = false;
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pindah-gudangs/print/'+self.pindahGudang.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        save() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    this._save();
                }
            });
        },

        _save() {
            let self = this,
                data = null;

            self.isLoading = true;

            if (self.isPenerimaan) {
                data = Object.assign({}, {
                    kemasan_ids: [],
                    bobot_tibas: [],
                    grade_tiba_ids: [],
                });
                self.form.kemasans.forEach(kemasan => {
                    if (kemasan.bobot_tiba && kemasan.grade_tiba) {
                        data.kemasan_ids.push(kemasan.id);
                        data.bobot_tibas.push(kemasan.bobot_tiba);
                        data.grade_tiba_ids.push(kemasan.grade_tiba.id);
                    }
                });
            } else if (self.isPelunasan) {
                data = Object.assign({}, {
                    pelunasan: self.form.pelunasan,
                    metode_pelunasan: self.form.metode_pelunasan.name,
                });
            }

            let api = '/api/pindah-gudangs/'+self.pindahGudang.id+(self.isPenerimaan ? '/penerimaan' : '/pelunasan');

            self.$Progress.start();
            axios({
                method: 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.isLoading = false;
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        printQrCode(data) {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pembelian-tembakaus/print/' + data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        searchBarang() {
            this.filterCode = this.searchText;
        },

        resetSearchBarang() {
            this.searchText = null;
            this.filterCode = this.searchText;
        },

        loadPilihan() {
            this.loadGrades();
        },

        loadGrades() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: 'get',
                url: '/api/grades',
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: 'Load grade berhasil'
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.gradeOptions = Object.assign([], response.data.data);
                self.gradeLoaded = true;
            })
            .catch(function (error) {
                self.requestFailed(error);
                self.gradeLoaded = false;
            });
        },

        updateGrade() {
            this.form.kemasans = Object.assign([], this.form.kemasans);
        },

        scanned(value) {
            let self = this;

            self.searchText = value;
            self.scanBarang = false;
            self.filterCode = self.searchText;
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
